// shared/SoyTiendaHeader.jsx

import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { brand } from "./brand";

const NAV_ITEMS = [
  { label: "Plataforma", to: "/?scroll=tecnologia" },
  { label: "Cómo funciona", to: "/?scroll=proceso" },
  { label: "Soluciones", to: "/?scroll=soluciones" },
  { label: "Cobertura", to: "/?scroll=cobertura" },
  { label: "Precios", to: "/?scroll=precios" },
];

export function SoyTiendaHeader() {
  return (
    <header className="sticky top-0 z-50 border-b bg-white/85 shadow-sm backdrop-blur-xl" style={{ borderColor: brand.line }}>
      <nav className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-2 sm:h-14 sm:flex-nowrap sm:gap-3 sm:py-0">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="FAST MAX" className="h-7 w-auto" />
          <span className="hidden text-base font-black italic tracking-wide sm:inline" style={{ color: brand.primary }}>
            FAST MAX
          </span>
        </Link>

        <div className="hidden items-center gap-5 text-xs font-bold md:flex" style={{ color: brand.muted }}>
          {NAV_ITEMS.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className="font-bold transition-opacity hover:opacity-70"
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="flex min-w-0 shrink-0 items-center justify-end gap-2">
          <Link
            to="/login"
            className="inline-flex min-w-0 items-center justify-center rounded-xl border bg-white px-3 py-1.5 text-center text-[11px] font-bold transition-colors hover:bg-slate-50 sm:text-xs"
            style={{ borderColor: brand.line, color: brand.ink }}
          >
            Iniciar sesión
          </Link>

          <Link
            to="/register"
            className="inline-flex min-w-0 items-center justify-center gap-1 rounded-xl px-3 py-1.5 text-[11px] font-bold text-white sm:text-xs"
            style={{ background: brand.primary }}
          >
            Crear cuenta
            <ChevronRight className="size-3.5 shrink-0" />
          </Link>
        </div>
      </nav>
    </header>
  );
}
